import React from 'react';

import { Spacer } from '@shared/components/helpers';

import { useTitle } from '@admin/hooks/use_title';

import { StorageTreasuresAuctionList } from '../storage_treasures/auction_list';
import { AuctionUploadList } from './uploads/list';

export const AuctionsIndex: React.FC = () => {
  useTitle('Auctions');
  return (
    <>
      <StorageTreasuresAuctionList />
      <Spacer />
      <AuctionUploadList />
    </>
  );
};
